export const coreAddresses = {
  balanceTracker: "0x7aeeC40fE0c08030aE79A1756383aec241e1aEbB",
  eVaultFactory: "0x47Aaf2f062aa1D55AFa602f5C9597588f71E2d76",
  eVaultImplementation: "0xb0703dc0569380a0b632C4bd3d7e446291CAf8eD",
  eulerEarnFactory: "0xcAFd42604Cbb4c8CA3352b2eff082d8a8Ebc4850",
  evc: "0xD9867dd8617B2055EdB9D0775450f453Dd5341dd",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0xA2939a0fA1Bdd96670B8BeB1f343CEC3F48856E9",
  sequenceRegistry: "0xDF30B6E7747f193641AF661BdC683ed1705519A3",
} as const
